import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=d550d816&scoped=true&lang=pug"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d550d816",
  null
  
)

export default component.exports